<template>
  <div>
    <template v-if="$StoreSendSchedule && $StoreSendSchedule[transferStore]">
      <div v-if="deliveryData" class="border pl-1">
        <template v-if="deliveryData?.sendDayOfWeek">
          <!--          <p>Ближайшая отправка <strong>{{ deliveryData.sendDate }}</strong></p>-->
          <!--          <p><strong>{{ deliveryData.progressDays }}</strong> дня(ей) в пути</p>-->
          <p>Прибытие препарата на склад <strong>{{ deliveryData.deliveryDate }} ({{
              deliveryData.deliveryTime
            }}) {{ deliveryData.deliveryWeekDay }}</strong></p>
        </template>
        <template v-else>
          нет регулярной отправки
        </template>
      </div>
      <div v-if="runnerWorkSchedule">
        <p>Рабочие дни курьера</p>
        <p v-for="d in runnerWorkSchedule">{{ weekDays[d.day_num] }} <span
          class="badge badge-info">{{ d.time === '00:00:00' ? 'Выходной' : 'До ' + d.time }}</span></p>
      </div>
    </template>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  props: ['cityId', 'updateDeliveryDate'],
  data() {
    return {
      runnerWorkSchedule: null,
      loading: false,
      storeId: null,
      transferStore: null,
      deliveryData: null,
      weekDays: {
        1: 'Понедельник',
        2: 'Вторник',
        3: 'Среда',
        4: 'Четверг',
        5: 'Пятница',
        6: 'Суббота',
        7: 'Воскресенье',
      },
    }
  },
  computed: {
    $StoreSendSchedule() {
      return {};
      // return this.$store.getters['platform/storeSendSchedule'];
    },
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  watch: {
    $StoreSendSchedule() {
      this.updateDeliveryPoint();
    },
    cityId() {
      this.updateDeliveryPoint();
    }
  },
  created() {
    this.updateDeliveryPoint();
  },
  methods: {
    updateDeliveryPoint() {
      // console.log('---update');
      // const city = this.$AllCities.find((c) => c.id === +this.cityId);
      const city = Object.values(this.$AllCities).find(c => c.id === +this.cityId);
      if (!city) return;
      this.storeId = city.store.store_id;
      // this.transferStore = this.$StoreRelations[this.storeId][0];
      this.transferStore = 3;
      this.deliveryData = null;
      let sendData;
      // const currentDayOfWeek = moment().add(1, 'days').day();
      const currentDayOfWeek = moment().day();
      // console.log(currentDayOfWeek, sendData);
      if (!this.$StoreSendSchedule || !this.$StoreSendSchedule[this.transferStore]) return;
      if (this.$StoreSendSchedule[this.transferStore]?.sendSchedule && this.$StoreSendSchedule[this.transferStore]?.sendSchedule[this.storeId]) {
        this.$StoreSendSchedule[this.transferStore].sendSchedule[this.storeId].forEach((s) => {
          if (currentDayOfWeek < +s.dayOfWeek && (!sendData || +sendData.dayOfWeek > +s.dayOfWeek)) {
            sendData = {...s};
          }
        })
        // console.log(sendData);
        if (!sendData) {
          this.$StoreSendSchedule[this.transferStore].sendSchedule[this.storeId].forEach((s) => {
            if (!sendData || +sendData.dayOfWeek > +s.dayOfWeek) {
              sendData = {...s};
            }
          });
        }
      }
      this.deliveryData = {}
      if (sendData) {
        this.deliveryData.sendDayOfWeek = sendData.dayOfWeek;
        if (this.$StoreSendSchedule[this.transferStore].allowedToSend && this.$StoreSendSchedule[this.transferStore].allowedToSend[this.storeId]) {
          this.deliveryData.progressDays = +this.$StoreSendSchedule[this.transferStore].allowedToSend[this.storeId].days;
          this.deliveryData.deliveryTime = this.$StoreSendSchedule[this.transferStore].allowedToSend[this.storeId].time;
        }
        // let sendDate = moment().add(1, 'days');
        let sendDate = moment();
        if (currentDayOfWeek < this.deliveryData.sendDayOfWeek) {
          sendDate.add(this.deliveryData.sendDayOfWeek - currentDayOfWeek, 'days');
        } else {
          sendDate.add(7 - currentDayOfWeek, 'days').add(this.deliveryData.sendDayOfWeek, 'days');
        }

        this.runnerWorkSchedule = null;
        if (this.$StoreSendSchedule?.extraRecords?.workingTime) {
          const division = Object.values(this.$AllDivisions).find((d) => {
            return d.stores.find((s) => s.object_id === this.storeId);
          })
          // console.log(division);
          const workDays = this.$StoreSendSchedule.extraRecords.workingTime.find((t) => t.object_id === division?.id);
          if (workDays?.data?.free_days.length) {
            this.runnerWorkSchedule = _.orderBy(workDays.data.free_days, 'day_num');
            _.orderBy(workDays.data.free_days, 'day_num').forEach((d) => {
              if (sendDate.day() === +d.day_num) {
                // sendDate.add(1, 'days');
              }
            })
          }
        }

        this.deliveryData.sendDate = sendDate.format('DD.MM.YYYY');
        sendDate.add(this.deliveryData.progressDays, 'days');
        this.deliveryData.deliveryWeekDay = this.weekDays[sendDate.day()];
        this.deliveryData.deliveryDate = sendDate.format('DD.MM.YYYY');
        if (this.updateDeliveryDate) {
          this.updateDeliveryDate();
        }
      }
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
